import { render, staticRenderFns } from "./ChildrenShortCard.vue?vue&type=template&id=2e3f18d0&scoped=true&"
import script from "./ChildrenShortCard.vue?vue&type=script&lang=js&"
export * from "./ChildrenShortCard.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenShortCard.vue?vue&type=style&index=0&id=2e3f18d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f18d0",
  null
  
)

export default component.exports